import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpParameterCodec } from '@angular/common/http';
import { environment } from '@env/environment';
import {CustomURLEncoder} from '../../util/encodeUrl';
// tslint:disable-next-line: import-blacklist
import { BehaviorSubject } from 'rxjs';
@Injectable()

export class SsoLoginService  {
  private userRole = new BehaviorSubject(null);
    currentUserRoleSourceValue = this.userRole.asObservable();
  constructor(private httpClient: HttpClient) { }
  ssoValidateUser(email: string) {
    const params = new HttpParams()
    .set('email', email);
    return this.httpClient.get('users/validateSSoUser', { params: params });
  }
  getSamlRequests() {
    const params = new HttpParams()
    .set("RelayState", environment.SSO_RELAY_URL);
    return this.httpClient.get('ssos/getSamlRequest', { params: params });
  }
   loadAppConfig() {
        return this.httpClient.get('assets/resource/sso-data.xml', { responseType: 'text' });
      }
  sendSsoRequest(data) {
   let params: HttpParams = new HttpParams({encoder: new CustomURLEncoder() })
     .set("RelayState", environment.SSO_RELAY_URL)
     .set("SAMLRequest", encodeURI(data.SAMLRequest));

     return this.httpClient.post(data.entityEndpoint, params);
  }
  sendSsosignUpRequest(data) {
    let params: HttpParams = new HttpParams({encoder: new CustomURLEncoder() })
    .set("RelayState", environment.SSO_SIGNUP_RELAY_URL)
    .set("SAMLRequest", encodeURI(data.SAMLRequest));

    return this.httpClient.post(data.entityEndpoint, params);

  }
  setuserRoleSourceValue(val) {
    this.userRole.next(val);
  }
}






// WEBPACK FOOTER //
// ./src/app/shared/services/sso-login.service.ts